import { useSelector } from 'react-redux';
import cartUtils from '../../../../../../utils/cart';

const useOrderContainsSingleBackgroundUpgrade = (): boolean => {
  const orders = useSelector((state: any) => state.v3Order.orders);
  const { studentId } = useSelector((state: any) => state.additionalData);
  const { chargeForYpxBackgroundUpgrades } = useSelector(
    (state: any) => state.shoot,
  );

  return cartUtils.orderContainsSingleBackgroundUpgrade(
    orders,
    studentId,
    chargeForYpxBackgroundUpgrades,
  );
};

export default useOrderContainsSingleBackgroundUpgrade;
